import React from 'react';
import { CircularProgress, Typography, Paper, Breadcrumbs, Link, Grid } from '@mui/material';
import useViewEmbeddedReport from '../../hooks/embedded-reports/useViewEmbeddedReport';
import ErrorMessage from '../alerts/ErrorMessage';
import AnimatedCard from '../page-layout/animated-card/AnimatedCard';

const EmbeddedReportViewer = ({ reportIdentifier, queryParams, hideBreadcrumbs }) => {
    const { report, loading, error } = useViewEmbeddedReport({ reportIdentifier, queryParams });

    const showErrorContent = !loading && (error || !report?.embedUrl);

    const ErrorContent = () => {
        if (error) {
            return <ErrorMessage severity="error" title={'Error Displaying Report'} text={'Something went wrong fetching the requested report. Please try again or contact support if the issue persists.'} />;
        }

        if (!report?.embedUrl) {
            return <ErrorMessage severity="warning" title={'Unable to Find Report'} message={'We were not able to find the report you were looking for.'} />;
        }
    };

    const EmbeddedReport = ({ embeddedReport }) => (
        <>
            <Typography variant="h6" color="black">
                {embeddedReport.resourceName}
            </Typography>
            <hr />
            <iframe src={embeddedReport.embedUrl} title="embeddedReportViewer" height="100%" width="100%" />
        </>
    );

    return showErrorContent ? (
        <Paper>
            <ErrorContent />
        </Paper>
    ) : (
        <>
            <Grid item xs={12} alignSelf="start">
                {!hideBreadcrumbs && (
                    <Breadcrumbs sx={{ fontSize: 16, ml: 4 }}>
                        <Link color="inherit" href="#/reporting/">
                            Reporting
                        </Link>

                        {!error && !loading && <div>{report.resourceName}</div>}
                    </Breadcrumbs>
                )}
            </Grid>
            <AnimatedCard>
                {
                    loading ? <CircularProgress /> : <EmbeddedReport embeddedReport={report} />
                    // wrap
                }
            </AnimatedCard>
        </>
    );
};

export default EmbeddedReportViewer;
